import Vue from 'vue';
import axios from 'axios';

const INTERVALO_REVERIFICACAO_MS = 10 * 60 * 1000;
const SITUACOES = ['A', 'P', 'I'];

export const estadoTenant = Vue.observable({
  situacao: 'A',
  mensagem: '',
  previsaoRetorno: null,
  verificando: false,
  ultimaVerificacao: null,
});

export const bloqueado = () => estadoTenant.situacao === 'P' || estadoTenant.situacao === 'I';

// Sem os interceptors do axios global
const http = axios.create({ timeout: 10000, withCredentials: false });

let subdominioAtual = null;
let timerReverificacao = null;

const pararReverificacao = () => {
  if (timerReverificacao) clearTimeout(timerReverificacao);
  timerReverificacao = null;
};

const agendarReverificacao = () => {
  pararReverificacao();
  timerReverificacao = setTimeout(() => verificar(), INTERVALO_REVERIFICACAO_MS);
};

const aplicar = ({ situacao, mensagem, previsaoRetorno }) => {
  const estavaBloqueado = bloqueado();
  Object.assign(estadoTenant, { situacao, mensagem: mensagem || '', previsaoRetorno: previsaoRetorno || null });

  if (situacao === 'P') agendarReverificacao();
  else pararReverificacao();

  if (estavaBloqueado && situacao === 'A') window.location.reload();
};

export const verificar = async (subdominio = subdominioAtual) => {
  subdominioAtual = subdominio;
  if (!subdominio || estadoTenant.verificando) return estadoTenant.situacao;

  estadoTenant.verificando = true;
  try {
    const url = `${process.env.VUE_APP_BACKEND_URL}/api/existesubdominio?subdominio=${encodeURIComponent(subdominio)}`;
    const { data } = await http.get(url);
    const dados = (data && data.dados) || {};

    // Sem o campo situacao (endpoint antigo ou subdomínio não encontrado): segue como ativo
    const situacao = SITUACOES.includes(dados.situacao) ? dados.situacao : 'A';
    aplicar({ situacao, mensagem: dados.mensagem, previsaoRetorno: dados.previsaoRetorno });
  } catch (erro) {
    console.warn('[situacaoTenant] Não foi possível verificar a situação do tenant:', erro && erro.message);
    if (estadoTenant.situacao === 'P') agendarReverificacao();
  } finally {
    estadoTenant.verificando = false;
    estadoTenant.ultimaVerificacao = new Date();
  }
  return estadoTenant.situacao;
};

export const mensagemPersonalizada = (mensagem) => String(mensagem || '').trim();

const doisDigitos = (n) => String(n).padStart(2, '0');
const mesmoDia = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export const formatarHora = (data) => `${doisDigitos(data.getHours())}:${doisDigitos(data.getMinutes())}`;

export const formatarPrevisao = (previsao, agora = new Date()) => {
  if (!previsao) return '';
  const data = new Date(previsao);
  if (Number.isNaN(data.getTime()) || data.getTime() <= agora.getTime()) return '';

  const hora = formatarHora(data);
  const amanha = new Date(agora);
  amanha.setDate(amanha.getDate() + 1);

  if (mesmoDia(data, agora)) return `hoje às ${hora}`;
  if (mesmoDia(data, amanha)) return `amanhã às ${hora}`;
  const dia = `${doisDigitos(data.getDate())}/${doisDigitos(data.getMonth() + 1)}`;
  return data.getFullYear() === agora.getFullYear()
    ? `${dia} às ${hora}`
    : `${dia}/${data.getFullYear()} às ${hora}`;
};
